// extracted by mini-css-extract-plugin
export default {"wrapper":"FormMultipleAssetSelect_wrapper__qd7+h","field":"FormMultipleAssetSelect_field__nAJTe","field__qr":"FormMultipleAssetSelect_field__qr__R9aMM"};